import axios from "axios";
import store from "../../store";
import customModal from "../customModal/customModal.vue";

export default {
  name: "ArmModal",
  components: { customModal },
  props: { editingId: String },
  emits: ["closeModal", "saved", "refreshCraList"],

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      isEditMode: false,
      studyId: "",

      roleList: [],
      userList: [],
      sites: [],
      visitTypes: [],
      checklists: [],

      craDetails: {
        roleId: "",
        craEmail: ""
      },

      newCra: {
        siteId: "",
        plannedDate: "",
        endDate: "",
        visitType: "",
        checklistId: "",
        monitoringMode: "",
        triggeredBy: "",
        unit: "",
        value: "",
        status: "Planned",
        checklist: "",
        visitName: "",
        Comment: "",

      },
      checklist: "",

      formErrors: {},
      loading: true,


      monitoringModeOptions: ["Onsite", "Remote", "Hybrid", "Central"],
      triggeredByOptions: [
        "Protocol Scheduled",
        "Risk Signal Detected",
        "Major Protocol Deviation",
        "High Query Rate",
        "High AE Rate",
        "Missed Visit",
        "Manual Assignment",
        "Regulatory Requirement",
        "Others"
      ]
    };
  },

  async mounted() {
    this.token = store.getters.getIdToken;
    this.studyId = store.getters.getStudyIs;

    this.loading = !!this.editingId;

    await this.setRoleList();

    if (this.editingId) {
      this.isEditMode = true;
      await this.fetchCraScheduleById();
    } else {
      await this.onRoleChange();
    }

    await Promise.all([
      this.getsites(),
      this.getVisitTypes()
    ]);

    if (this.isEditMode) {
      this.loading = false;
    }
  },
  computed: {
    craRoleId() {
      const craRole = this.roleList.find(
        r => r.roleName?.toUpperCase() === "CRA"
      );
      return craRole?.roleID || "";
    },
    showRepeatPeriod() {
    return (
      !this.isEditMode &&
      this.newCra.visitType === "Site Monitoring"
    );
  }
  },



  methods: {
    closeModal() {
      this.$emit("closeModal");
    },

    async setRoleList() {
      const res = await axios.get(
        `${this.baseurl}/account-core/roles/rolelist`,
        { headers: { Authorization: `Bearer ${this.token}` } }
      );
      this.roleList = res.data || [];
    },
    async fetchCraScheduleById() {
      try {
        const res = await axios.get(
          `${this.baseurl}/forms/cra/getbyid`,
          {
            params: { id: this.editingId },
            headers: { Authorization: `Bearer ${this.token}` }
          }
        );

        const data = res.data;
        if (!data) return;

        this.craDetails.craEmail = data.craId;
        const roleId = await this.getRoleIdByEmail(data.craId);
        this.craDetails.roleId = roleId;
        await this.onRoleChange();

        this.newCra.siteId = data.siteId;

        this.newCra.plannedDate = data.plannedDate?.substring(0, 10) || "";
        this.newCra.endDate = data.endDate?.substring(0, 10) || "";

        this.newCra.visitType = data.craVisitType;
        await this.onVisitTypeChange();

        this.newCra.checklist = data.checklist?.[0] || "";

        this.newCra.monitoringMode = data.monitoringMode;
        this.newCra.triggeredBy = data.reason;
        this.newCra.status = data.status || "Planned";

        this.newCra.unit = data.repeatPeriod?.unit || "";
        this.newCra.value = data.repeatPeriod?.value || 0;

      } catch (err) {
        console.error("Failed to load CRA schedule", err);
      }
    },
    async getRoleIdByEmail(email) {
      const res = await axios.get(
        `${this.baseurl}/account-core/user/userlist`,
        {
          params: {
            Key: email,
            pageindex: 1,
            pagesize: 1
          },
          headers: { Authorization: `Bearer ${this.token}` }
        }
      );

      const roleName = res.data?.results?.[0]?.role?.[0];
      const role = this.roleList.find(r => r.roleName === roleName);
      return role?.roleID || "";
    },



    async onRoleChange() {
      if (!this.craRoleId) {
        console.warn("CRA role not found");
        return;
      }

      console.log("CRA Role ID:", this.craRoleId);

      if (!this.isEditMode) {
        this.craDetails.craEmail = "";
      }

      const res = await axios.get(
        `${this.baseurl}/account-core/user/getusersbyrole`,
        {
          params: {
            roleids: this.craRoleId,
            studyid: this.studyId
          },
          headers: { Authorization: `Bearer ${this.token}` }
        }
      );

      this.userList = res.data || [];
    },



    async getsites() {
      const res = await axios.get(
        `${this.baseurl}/management/site/getall`,
        {
          params: { studyId: this.studyId },
          headers: { Authorization: `Bearer ${this.token}` }
        }
      );
      this.sites = res.data || [];
    },

    async getVisitTypes() {
      const res = await axios.get(
        `${this.baseurl}/forms/cra/getcravisittype`,
        { headers: { Authorization: `Bearer ${this.token}` } }
      );
      this.visitTypes = res.data || [];
    },

    async onVisitTypeChange() {
      this.newCra.checklistId = "";
      this.checklists = [];

      if (!this.newCra.visitType) return;

      const res = await axios.get(
        `${this.baseurl}/forms/cra/getchecklistbyvisit`,
        {
          params: { visittype: this.newCra.visitType },
          headers: { Authorization: `Bearer ${this.token}` }
        }
      );

      this.checklists = res.data?.[0]?.checklist || [];
    },
    validateForm() {
      this.formErrors = {};

      if (!this.craDetails.craEmail) {
        this.formErrors.cra = "CRA is required";
      }

      if (!this.newCra.siteId) {
        this.formErrors.sites = "Site is required";
      }

      if (!this.newCra.plannedDate) {
        this.formErrors.plannedDate = "Planned date is required";
      }

      return Object.keys(this.formErrors).length === 0;
    },

    async submitCraSchedule() {
      if (!this.validateForm()) {
        return;
      }

      const userEmail = store.getters.getUserEmail;
      const userId = store.getters.getUserId;
      const now = new Date().toISOString();

      const selectedSite = this.sites.find(
        s => s.siteID === this.newCra.siteId
      );

      const payload = {
        createdUserEmail: userEmail,
        createdUserId: userId,
        createdAt: now,
        lastModifiedUserEmail: userEmail,
        lastModifiedUserId: userId,
        lastModifiedAt: now,

        studyId: this.studyId,
        craId: this.craDetails.craEmail,
        siteId: selectedSite?.siteID || "",
        siteCode: selectedSite?.siteCode || "",

        craVisitType: this.newCra.visitType,
        visitName: this.newCra.visitName || "",
        monitoringMode: this.newCra.monitoringMode,

        plannedDate: new Date(this.newCra.plannedDate).toISOString(),
        actualDate: null,

        status: this.newCra.status || "Planned",
        reason: this.newCra.triggeredBy || "",
        comment: this.newCra.triggeredBy === 'Others' ? this.newCra.Comment : '',

        immediateDate: new Date(this.newCra.plannedDate).toISOString(),
        overridePlannedDate: false,

        checklist: this.newCra.checklist
          ? [this.newCra.checklist]
          : [],

        endDate: this.newCra.endDate
          ? new Date(this.newCra.endDate).toISOString()
          : null,


        repeatPeriod: {
          value: Number(this.newCra.value || 0),
          unit: this.newCra.unit || ""
        }
      };

      await axios.post(
        `${this.baseurl}/forms/cra/craschedulecreate`,
        payload,
        { headers: { Authorization: `Bearer ${this.token}` } }
      );
alert("CRA schedule created successfully");
      this.$emit("saved");
      this.$emit("refreshCraList");
      this.closeModal();
    },
async updateCraSchedule() {
  this.formErrors = {};

  if (!this.craDetails.craEmail) {
    this.formErrors.cra = "CRA is required";
  }
  if (!this.newCra.plannedDate) {
    this.formErrors.plannedDate = "Planned date is required";
  }
  if (!this.newCra.status) {
    this.formErrors.status = "Status is required";
  }

  if (Object.keys(this.formErrors).length > 0) return;

  const payload = {
    craId: this.craDetails.craEmail,
    craScheduleId: this.editingId,
    plannedDate: new Date(this.newCra.plannedDate).toISOString(),
    status: this.newCra.status
  };

  try {
    await axios.put(
      `${this.baseurl}/forms/cra/crascheduleupdate`,
      payload,
      { headers: { Authorization: `Bearer ${this.token}` } }
    );

    this.$emit("saved");
    this.$emit("refreshCraList");
    this.closeModal();

    alert("CRA schedule updated successfully"); 
  } catch (err) {
    console.error("Failed to update CRA schedule", err);
    alert("Failed to update CRA schedule"); 
  }
}





    // async submitAllCra() {
    //   if (!this.craDetails.roleId || !this.craDetails.craEmail) {
    //     alert("Role and CRA are required");
    //     return;
    //   }

    //   const payload = {
    //     craId: this.craDetails.craEmail,
    //     studies: [{
    //       studyId: this.studyId,
    //       sites: [{
    //         siteId: this.newCra.siteId,
    //         plannedDate: new Date(this.newCra.plannedDate).toISOString(),
    //         repeatPeriod: {
    //           unit: this.newCra.unit,
    //           value: Number(this.newCra.value)
    //         }
    //       }]
    //     }]
    //   };

    //   await axios.post(
    //     `${this.baseurl}/forms/cra/assigncra`,
    //     payload,
    //     { headers: { Authorization: `Bearer ${this.token}` } }
    //   );

    //   this.$emit("saved");
    //   this.$emit("refreshCraList");
    //   this.closeModal();
    // }
  }
};
